import React, { useState } from 'react';
import './styles.css';

export const DeleteConfirmationModal = ({isOpen, onClose, onConfirm, inventoryName, isDeleting, title = 'Delete Inventory'}) =>
{
  if (!isOpen) return null;

  const handleOverlayClick = (e) =>
  {
    if (!isDeleting)
    {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content delete-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
          <button
            className="modal-close"
            onClick={onClose}
            disabled={isDeleting}
          >
            ×
          </button>
        </div>

        <div className="modal-body">
          <p className="delete-confirmation-message">
            Are you sure you want to delete <strong>{inventoryName}</strong>?
          </p>
          <p className="delete-warning-message">
            This action cannot be undone.
          </p>
        </div>

        <div className="modal-footer">
          <button
            className="btn-cancel"
            onClick={onClose}
            disabled={isDeleting}
          >
            No
          </button>
          <button
            className="btn-delete"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};
